(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["et-custom-order"] && !Shopify.designMode) return;
  try {
    function setupEtIntake(){
const form=document.getElementById('EtCustomOrder');if(!form||form.dataset.ready)return;form.dataset.ready='true';
const type=form.querySelector('#et-type'),delivery=form.querySelector('#et-delivery');if(!type)return;
function toggle(container,show){container.hidden=!show;container.querySelectorAll('input,select,textarea').forEach(field=>{field.disabled=!show;});}
function refresh(){toggle(form.querySelector('.et-intake-apparel'),type.value==='Custom tees or apparel');toggle(form.querySelector('.et-intake-dimensions'),type.value!==''&&type.value!=='Custom tees or apparel');toggle(form.querySelector('.et-intake-shipping'),delivery.value==='Shipping');}
type.addEventListener('change',refresh);delivery.addEventListener('change',refresh);refresh();

}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setupEtIntake);else setupEtIntake();
document.addEventListener('shopify:section:load',setupEtIntake);
  } catch(e) { console.error(e); }
})();

})();
